import {
  Button,
  Drawer,
  DrawerProps,
  FluentProvider,
  PartialTheme,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

import DrawerHeader from "./DrawerHeader";
import DrawerHeaderTitle from "./DrawerHeader/DrawerHeaderTitle";
import { Dismiss24Regular } from "@fluentui/react-icons";

interface DrawerCustomProps {
  headerText?: string;
  onDismiss?: () => void;
  rcName?: string;
  theme?: string;
}

const DrawerCustom = (props: DrawerCustomProps & DrawerProps) => {
  const renderTheme: PartialTheme = props.theme === "dark" ? webDarkTheme : webLightTheme;
  return (
    <FluentProvider theme={renderTheme}>
      <Drawer separator {...props} position="end">
        {props.headerText && (
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <Button
                  appearance="subtle"
                  aria-label="Close"
                  icon={<Dismiss24Regular />}
                  onClick={props.onDismiss}
                />
              }
            >
              {props.headerText}
            </DrawerHeaderTitle>
          </DrawerHeader>
        )}
        {props.children}
      </Drawer>
    </FluentProvider>
  );
};

export default DrawerCustom;
